/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCoinInfo = {
    COINID: string;
    LOGO: string;
    NM: string;
    SB: string;
    ASTTP: string;
    PRC: string;
    PRC24H: string;
    MKC: string;
    FDV: string;
    VM24H: string;
    VMC24H: string;
    HD: string;
    HD24H: string;
    PCT: AptosCoinInfo.PCT;
    PST: AptosCoinInfo.PST;
};

export namespace AptosCoinInfo {

    export enum PCT {
        NATIVE = 'NATIVE',
        EMOJICOIN = 'EMOJICOIN',
        MEME = 'MEME',
        BRIDGED = 'BRIDGED',
        NONE = 'NONE',
    }

    export enum PST {
        VERIFIED = 'VERIFIED',
        RECOGNIZED = 'RECOGNIZED',
        UNVERIFIED = 'UNVERIFIED',
        BANNED = 'BANNED',
        INTERNAL_FA = 'INTERNAL_FA',
        LP = 'LP',
        NONE = 'NONE',
    }


}

